import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

import { Router, RouterModule } from '@angular/router';
import { appstraxAuth, MessageDto } from '@appstrax/services/auth';
import { mapAuthErrorMessage } from '../../../utils/auth-error.util';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.page.html',
  styleUrls: ['./forgot-password.page.scss'],
  standalone: true,
  imports: [CommonModule, FormsModule, RouterModule],
})
export class ForgotPasswordPage {
  errorMessage: string = '';
  isLoading: boolean = false;
  showResetPassword: boolean = false;
  email: string = '';
  code: string = '';
  password: string = '';

  constructor(private router: Router) {}

  public async sendEmail() {
    if (!this.isSendEmailFormValid()) {
      this.errorMessage = 'Please enter your email';
      return;
    }

    this.isLoading = true;
    this.errorMessage = '';

    try {
      const response: MessageDto = await appstraxAuth.forgotPassword({ email: this.email });
      if (response) {
        this.showResetPassword = true;
      }
    } catch (error: any) {
      this.errorMessage = mapAuthErrorMessage(error);
    } finally {
      this.isLoading = false;
    }
  }

  public isSendEmailFormValid() {
    return this.email != '';
  }

  public async resetPassword() {
    if (!this.isResetPasswordFormValid()) {
      this.errorMessage = 'Please enter your email, code and password';
      return;
    }

    this.isLoading = true;
    this.errorMessage = '';

    try {
      const response: MessageDto = await appstraxAuth.resetPassword({ email: this.email, code: this.code, password: this.password });
      if (response) {
        this.router.navigate(['/login']);
      }
    } catch (error: any) {
      this.errorMessage = mapAuthErrorMessage(error);
    } finally {
      this.isLoading = false;
    }
  }

  public isResetPasswordFormValid() {
    return this.email != '' && this.code != '' && this.password != '';
  }
}
